import React, { useState, useEffect } from "react";
import Step0 from "../Step0/Step0";
import Step1 from "../Step1/Step1";
import Step2 from "../Step2/Step2";
import Step3 from "../Step3/Step3";
import Step4 from "../Step4/Step4";
import Step5 from "../Step5/Step5";
import Step6 from "../Step6/Step6";
import Step7 from "../Step7/Step7";

const STEP_TITLES = {
  step1: "Персональные данные",
  step2: "Тип участия",
  step31: "Информация о физическом лице",
  step32: "Информация о юридическом лице",
  step4: "Выбор задачи",
  step5: "Решение",
  finish: "Спасибо",
};

function Form() {
  const [title, setTitle] = useState("Персональные данные");

  const [step, setStep] = useState(0);

  // step 1
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [telegram, setTelegram] = useState("");
  const [dataAgreement, setDataAgreement] = useState(false);

  //step2
  const [participationType, setParticipationType] = useState(null);

  // step3.1

  const [city, setCity] = useState("");
  const [place, setPlace] = useState("");
  const [haveIp, setHaveIp] = useState("2");
  const [inn, setInn] = useState("");
  const [specialization, setSpecialization] = useState("");
  const [expiration, setExpiration] = useState("");
  const [portfolio, setPortfolio] = useState("");
  const [format, setFormat] = useState("single");
  const [command, setCommand] = useState("");

  // step3.2

  const [position, setPosition] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [legalName, setLegalName] = useState("");
  const [special, setSpecial] = useState("");
  const [otherSpecial, setOtherSpecial] = useState("");
  const [ogrn, setOgrn] = useState("");
  const [site, setSite] = useState("");
  const [companyExpiration, setCompanyExpiration] = useState("");
  const [comapanyCommand, setComapanyCommand] = useState("");
  const [addMaterials, setAddMaterials] = useState("");

  // step 4

  const [task, setTask] = useState([]);

  // step 5

  const [solution, setSolution] = useState("");
  const [uniqSolution, setUniqSolution] = useState("");
  const [tools, setTools] = useState("");
  const [results, setResults] = useState("");
  const [sources, setSources] = useState("");
  const [budget, setBudget] = useState("");
  const [presentation, setPresentation] = useState("");
  const [materials, setMaterials] = useState("");
  const [agree, setAgree] = useState(false);

  // ------------------------------------------

  useEffect(() => {
    if (step === 1) {
      setTitle(STEP_TITLES.step1);
    }
    if (step === 2) {
      setTitle(STEP_TITLES.step2);
    }
    if (step === 3) {
      if (participationType === "1") {
        setTitle(STEP_TITLES.step31);
      }
      if (participationType === "2") {
        setTitle(STEP_TITLES.step32);
      }
    }
    if (step === 4) {
      setTitle(STEP_TITLES.step4);
    }

    if (step === 5) {
      setTitle(STEP_TITLES.step5);
    }
  }, [step, participationType]);

  return (
    <div className="mm-form">
      {step !== 0 && step !== 6 && step !== 7 && step !== 8 && (
        <>
          <div className="mm-form-steps">
            <div className="mm-form-steps__item mm-form-steps__item_active"></div>
            <div
              className={
                step >= 2
                  ? "mm-form-steps__item mm-form-steps__item_active"
                  : "mm-form-steps__item"
              }
            ></div>
            <div
              className={
                step >= 3
                  ? "mm-form-steps__item mm-form-steps__item_active"
                  : "mm-form-steps__item"
              }
            ></div>
            <div
              className={
                step >= 4
                  ? "mm-form-steps__item mm-form-steps__item_active"
                  : "mm-form-steps__item"
              }
            ></div>
{/*            <div
              className={
                step >= 5
                  ? "mm-form-steps__item mm-form-steps__item_active"
                  : "mm-form-steps__item"
              }
            ></div>*/}
          </div>

          <div className="mm-form-header">
            <div className="mm-form-header__step">Шаг {step}</div>
            <div className="mm-form-header__title">{title}</div>

            <div
              className={`mm-form-header__count mm-form-header__count-${step}`}
            >
              <div>{step}/4</div>
            </div>
          </div>
        </>
      )}

      {(() => {
        switch (step) {
          case 1:
            return (
              <Step1
                setStep={setStep}
                name={name}
                setName={setName}
                surname={surname}
                setSurname={setSurname}
                email={email}
                setEmail={setEmail}
                phone={phone}
                setPhone={setPhone}
                telegram={telegram}
                setTelegram={setTelegram}
                dataAgreement={dataAgreement}
                setDataAgreement={setDataAgreement}
              />
            );
          case 2:
            return (
              <Step2
                setParticipationType={setParticipationType}
                participationType={participationType}
                setStep={setStep}
              />
            );
          case 3:
            return (
              <Step3
                name={name}
                surname={surname}
                email={email}
                phone={phone}
                telegram={telegram}
                participationType={participationType}
                setParticipationType={setParticipationType}
                setStep={setStep}
                city={city}
                setCity={setCity}
                place={place}
                setPlace={setPlace}
                haveIp={haveIp}
                setHaveIp={setHaveIp}
                inn={inn}
                setInn={setInn}
                specialization={specialization}
                setSpecialization={setSpecialization}
                expiration={expiration}
                setExpiration={setExpiration}
                portfolio={portfolio}
                setPortfolio={setPortfolio}
                format={format}
                setFormat={setFormat}
                command={command}
                setCommand={setCommand}
                position={position}
                setPosition={setPosition}
                companyName={companyName}
                setCompanyName={setCompanyName}
                legalName={legalName}
                setLegalName={setLegalName}
                special={special}
                setSpecial={setSpecial}
                otherSpecial={otherSpecial}
                setOtherSpecial={setOtherSpecial}
                ogrn={ogrn}
                setOgrn={setOgrn}
                site={site}
                setSite={setSite}
                companyExpiration={companyExpiration}
                setCompanyExpiration={setCompanyExpiration}
                comapanyCommand={comapanyCommand}
                setComapanyCommand={setComapanyCommand}
                addMaterials={addMaterials}
                setAddMaterials={setAddMaterials}
                dataAgreement={dataAgreement}
                setDataAgreement={setDataAgreement}
              />
            );
          case 4:
            return <Step4
              setStep={setStep}
              task={task}
              setTask={setTask}

              name={name}
              surname={surname}
              email={email}
              phone={phone}
              telegram={telegram}
              participationType={participationType}
              setParticipationType={setParticipationType}
              city={city}
              setCity={setCity}
              place={place}
              setPlace={setPlace}
              haveIp={haveIp}
              setHaveIp={setHaveIp}
              inn={inn}
              setInn={setInn}
              specialization={specialization}
              setSpecialization={setSpecialization}
              expiration={expiration}
              setExpiration={setExpiration}
              portfolio={portfolio}
              setPortfolio={setPortfolio}
              format={format}
              setFormat={setFormat}
              command={command}
              setCommand={setCommand}
              position={position}
              setPosition={setPosition}
              companyName={companyName}
              setCompanyName={setCompanyName}
              legalName={legalName}
              setLegalName={setLegalName}
              special={special}
              setSpecial={setSpecial}
              otherSpecial={otherSpecial}
              setOtherSpecial={setOtherSpecial}
              ogrn={ogrn}
              setOgrn={setOgrn}
              site={site}
              setSite={setSite}
              companyExpiration={companyExpiration}
              setCompanyExpiration={setCompanyExpiration}
              comapanyCommand={comapanyCommand}
              setComapanyCommand={setComapanyCommand}
              addMaterials={addMaterials}
              setAddMaterials={setAddMaterials}
              dataAgreement={dataAgreement}
              setDataAgreement={setDataAgreement}

              agree={agree}
              setAgree={setAgree}
            />;
          case 5:
            return (
              <Step5
                name={name}
                surname={surname}
                email={email}
                phone={phone}
                telegram={telegram}
                participationType={participationType}
                city={city}
                place={place}
                haveIp={haveIp}
                inn={inn}
                specialization={specialization}
                expiration={expiration}
                portfolio={portfolio}
                format={format}
                command={command}
                position={position}
                companyName={companyName}
                legalName={legalName}
                special={special}
                otherSpecial={otherSpecial}
                ogrn={ogrn}
                site={site}
                companyExpiration={companyExpiration}
                comapanyCommand={comapanyCommand}
                addMaterials={addMaterials}
                dataAgreement={dataAgreement}
                setStep={setStep}
                solution={solution}
                setSolution={setSolution}
                uniqSolution={uniqSolution}
                setUniqSolution={setUniqSolution}
                tools={tools}
                setTools={setTools}
                results={results}
                setResults={setResults}
                sources={sources}
                setSources={setSources}
                budget={budget}
                setBudget={setBudget}
                presentation={presentation}
                setPresentation={setPresentation}
                materials={materials}
                setMaterials={setMaterials}
                agree={agree}
                setAgree={setAgree}
                task={task}
              />
            );
          case 6:
            return <Step6 />;
          case 7:
            return <Step7 />;
          default:
            return <Step0 setStep={setStep} />;
        }
      })()}
    </div>
  );
}

export default Form;
